<template>
  <div class="cbg-white-container blog-details-main theme--light v-card p-3">
    <div class="col-sm-12 px-0 flex-end mb-2 mob-f-s">
      <v-btn
        v-if="
          permissions.includes('CAN_DELETE_ADMIN_BLOGS') &&
          !!blogDetails.is_published &&
          blogDetails.status === 'APPROVED' &&
          (this.$store.state.user.userDetails.is_super == true ||
            blogDetails.admin_user_id == this.$store.state.user.userDetails._id)
        "
        disabled
        color="error"
        class="mr-4"
        @click="openSwal('delete', blogDetails._id)"
        >Delete</v-btn
      >
      <v-btn
        v-else-if="
          permissions.includes('CAN_DELETE_ADMIN_BLOGS') &&
          !blogDetails.is_published &&
          blogDetails.status === 'APPROVED' &&
          (this.$store.state.user.userDetails.is_super == true ||
            blogDetails.admin_user_id == this.$store.state.user.userDetails._id)
        "
        color="error"
        class="mr-4"
        @click="openSwal('delete', blogDetails._id)"
        >Delete</v-btn
      >
      <span
        v-if="!!blogDetails.is_published && blogDetails.status === 'APPROVED'"
      >
        <v-btn
          v-if="
            permissions.includes('CAN_UNPUBLISH_ADMIN_BLOGS') &&
            (this.$store.state.user.userDetails.is_super == true ||
              blogDetails.admin_user_id ==
                this.$store.state.user.userDetails._id)
          "
          color="success"
          @click="openSwal('unpublish', blogDetails._id)"
          >Unpublish</v-btn
        >
      </span>
      <span v-else>
        <v-btn
          v-if="
            permissions.includes('CAN_PUBLISH_ADMIN_BLOGS') &&
            (this.$store.state.user.userDetails.is_super == true ||
              blogDetails.admin_user_id ==
                this.$store.state.user.userDetails._id)
          "
          color="success"
          @click="openSwal('publish', blogDetails._id)"
          >Publish</v-btn
        >
      </span>
      <!-- <v-btn color="success" >Unpublish</v-btn> -->
    </div>
    <div class="blog-image">
      <image-view
        :src="
          blogDetails.cover_photo
            ? blogDetails.cover_photo
            : '/img/avatars/default-blog.png'
        "
        alt="user image"
      ></image-view>
    </div>
    <div>
      <h5 class="mt-3 text-capitalize">{{ blogDetails.title }}</h5>
      <p class="text-capitalize">{{ blogDetails.short_description }}</p>
      <p class="mb-0 text-capitalize">
        By DocSmart
        <b>{{ getBlogDate(blogDetails.blog_update) }}</b>
      </p>
      <div class="col-sm-12 p-0 blog-links d-just-space my-4">
        <div v-if="blogStatus.includes(blogDetails.status) && blogDetails.is_published" class="share-blog d-align ml--12">
          <share-blogs></share-blogs>
        </div>
        <div class="mb-2">
          <div class="d-flex">
            <div class="blog-count mr-3 d-align">
              <image-view
                :src="'/img/avatars/visibility.png'"
                class="mr-1 eye-view"
              ></image-view>
              <p class="mb-0">{{ blogDetails.views_count }}</p>
            </div>
            <div class="blog-count mr-3 d-align" @click="scrollToComment()">
              <image-view
                :src="'/img/avatars/speech-bubble.png'"
                class="mr-1"
              ></image-view>
              <p class="mb-0">{{ commentNumber }}</p>
            </div>
            <div class="blog-count d-align">
              <image-view
                :src="'/img/avatars/like.png'"
                class="mr-1"
              ></image-view>
              <p class="mb-0">{{ blogDetails.likes_count }}</p>
            </div>
          </div>
        </div>
      </div>
      <hr class="my-4" />
      <div class="col-sm-12 p-0">
        <h5 class="text-capitalize">
          <b>Tags</b>
        </h5>
        <div class="chip-list">
          <v-chip
            v-for="(tag, i) in blogDetails.tags"
            :key="i"
            class="text-capitalize cursor mr-2"
            label
          >
            <router-link
              :to="{ name: 'Blogs Listing', params: { tag: tag } }"
              tag="h5"
              class="text-capitalize m-0"
              >{{ tag }}</router-link
            >
          </v-chip>
        </div>
      </div>
      <hr class="my-4" />
      <p class="el-tiptap-editor__content" v-html="blogDetails.description"></p>
      <div class="col-sm-12 p-0">
        <div class="d-just-space mb-4" id="comment-count">
          <div class="d-flex">
            <!-- <v-btn color="success" class="mr-4">Comment</v-btn> -->
            <h5 class="m-0 text-capitalize">{{ commentNumber }} Comments</h5>
          </div>
          <p
            v-if="commentNumber > 3"
            class="m-0 cursor text-capitalize"
            @click="showAllComments()"
          >
            Show all comments
          </p>
        </div>
      </div>
      <div class="col-sm-12 p-0">
        <div
          v-for="(comment, i) in commentDetails"
          :key="i"
          class="mt-3 border-bottom"
        >
          <p class="mb-0 text-capitalize">
            <b>{{ comment.commented_by.full_name }}</b>
          </p>
          <p class="mb-2 text-capitalize">
            {{ getCommentDate(comment.created_at) }}
          </p>
          <div class="col-sm-12 p-0 d-flex">
            <div class="col-sm-11 p-0">
              <p class="text-capitalize">{{ comment.comment }}</p>
            </div>
            <div
              @click="openSwal('delete-comment', comment._id)"
              class="col-sm-1 py-0 flex-end"
            >
              <deleteSVG class="cursor w-1" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <loader v-if="showLoader"></loader>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import config from "@/config.js";
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .isBetween()
  .build();
import "@/assets/scss/_blogs.scss";
const Image = () => import("@/components/image.vue");
// const EditImage = () =>
const Datepicker = () => import("v-calendar/lib/components/date-picker.umd");
const ShareBlogs = () => import("@/components/modals/shareBlog.vue");
const loader = () => import("@/components/loader.vue");
import { pickSvg } from "@/views/SVG";
import { bus } from "@/main.js";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      slug: this.$route && this.$route.params && this.$route.params.slug,
      blogTitle:
        this.$route && this.$route.params && this.$route.params.blogTitle,
      blogDetails: {},
      dayJS,
      currentPage: 1,
      recordPerPage: 3,
      commentDetails: [],
      commentNumber: "",
      showLoader: false,
      blogStatus: ["APPROVED"]
    };
  },
  computed: {
    ...mapGetters({
      permissions: "getPermissions",
    }),
  },
  created() {
    localStorage.setItem(
      "currentPathName",
      `/blog/${this.slug}${this.blogTitle ? `/${this.blogTitle}` : ""}`
    );
  },
  beforeRouteLeave(to, from, next) {
    localStorage.removeItem("currentPathName");
    bus.$emit("CHAT_BREADCRUMB_CHANGE", []);
    next();
  },
  mounted() {
    this.getBlogDetails();
    this.getComments();
  },
  components: {
    Datepicker,
    "image-view": Image,
    "share-blogs": ShareBlogs,
    loader,
    ...pickSvg("deleteSVG"),
  },
  methods: {
    scrollToComment() {
      const el = document.getElementById("comment-count");
      el.scrollIntoView({ behavior: "smooth" });
    },
    openRejectModal() {
      this.rejectModal = true;
    },
    closeRejectModal() {
      this.rejectModal = false;
    },
    getBlogDetails() {
      this.showLoader = true;
      let url = `${config.BASE_URL}api/v2/admin/blogs/${this.slug}/admin`;
      this.$http.get(url, {}).then((response) => {
        if (response.body.status) {
          if (response.body.data) {
            this.showLoader = false;
            this.blogDetails = { ...response.body.data };
            bus.$emit("CHAT_BREADCRUMB_CHANGE", [
              {
                text: "Home",
                disabled: !this.permissions.includes("VIEW_DASHBOARD"),
                to: "/",
              },
              {
                text: "Blogs Listing",
                disabled: false,
                to: "/blogs-listing",
              },
              {
                text: this.blogDetails.title,
                disabled: true,
                to: this.$route.path,
              },
            ]);
          } else {
            this.showLoader = false;
            this.blogDetails = {};
          }
        }
      });
    },
    showAllComments() {
      this.recordPerPage = this.commentNumber;
      this.getComments();
    },
    getComments() {
      this.showLoader = true;
      this.commentDetails = {};
      let url = `${config.BASE_URL}api/v2/admin/blog/comment/${this.slug}`;
      let params = {
        page: this.currentPage,
        records_per_page: this.recordPerPage,
      };
      this.$http.get(url, { params }).then((response) => {
        if (response.body.status) {
          this.showLoader = false;
          this.commentNumber = response.body.data.count;
          if (response.body.data.list) {
            this.commentDetails = response.body.data.list;
          } else {
            this.commentDetails = {};
          }
        } else {
          this.showLoader = false;
        }
      });
    },
    getBlogDate(date) {
      return dayJS(date).format("Do MMMM YYYY");
    },
    getCommentDate(date) {
      return dayJS(date).format("DD/MM/YYYY hh:mm a");
    },
    deleteComment(id) {
      let url = `${config.BASE_URL}api/v2/admin/comment/${id}`;
      this.$http.delete(url, {}).then((response) => {
        if (!!response.body.status) {
          Swal.fire({
            toast: true,
            icon: "success",
            html: "<p> <b>" + "Comment Deleted Successfully" + "</b></p>",
            showCancelButton: false,
            showConfirmButton: false,
            position: "bottom",
            customClass: "bottom-swal",
            timer: 6000,
          });
        }
        this.commentDetails = {};
        this.getComments();
      });
    },
    openSwal(status, id) {
      if (status === "delete") {
        Swal.fire({
          title: "Are you sure you want to Delete this blog",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        }).then((result) => {
          if (result.isConfirmed) {
            this.deleteBlog(id);
          }
        });
      } else if (status === "delete-comment") {
        Swal.fire({
          title: "Are you sure you want to Delete this comment",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        }).then((result) => {
          if (result.isConfirmed) {
            this.deleteComment(id);
          }
        });
      } else if (status === "unpublish") {
        Swal.fire({
          title: "Are you sure you want to Unpublish this blog",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        }).then((result) => {
          if (result.isConfirmed) {
            this.updateBlog(status, id);
          }
        });
      } else {
        Swal.fire({
          title: "Are you sure you want to Publish this blog",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        }).then((result) => {
          if (result.isConfirmed) {
            this.updateBlog(status, id);
          }
        });
      }
    },
    updateBlog(status, id) {
      this.showLoader = true;
      let obj = {
        title: this.blogDetails.title,
        cover_photo: this.blogDetails.cover_photo,
        short_description: this.blogDetails.short_description,
        description: this.blogDetails.description,
        tags: this.blogDetails.tags,
        status: status,
      };
      let url = `${config.BASE_URL}api/v2/admin/blogs/${id}`;
      this.$http.post(url, obj).then((response) => {
        if (!!response.ok) {
          this.showLoader = false;
          Swal.fire({
            title:
              status === "publish"
                ? "Blog Published Successfully"
                : "Blog Unpublished Successfully",
            icon: "success",
            showCancelButton: false,
            confirmButtonText: "Ok",
          }).then((result) => {
            if (result.isConfirmed) {
              this.goTo("/blogs-listing");
            }
          });
        }
      });
    },
    deleteBlog(id) {
      this.showLoader = true;
      let url = `${config.BASE_URL}api/v2/admin/blogs/${id}`;
      this.$http.delete(url, {}).then((response) => {
        if (!!response.ok) {
          this.showLoader = false;
          Swal.fire({
            title: "Blog Deleted Successfully",
            icon: "success",
            showCancelButton: false,
            confirmButtonText: "Ok",
          }).then((result) => {
            if (result.isConfirmed) {
              this.goTo("/blogs-listing");
            }
          });
        }
      });
    },
    goTo(url) {
      this.$router.push(url);
    },
  },
};
</script>